// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Open_Sans_481ce7', '__Open_Sans_Fallback_481ce7'","fontStyle":"normal"},"className":"__className_481ce7"};